<template>
    <v-expansion-panels>
        <v-expansion-panel v-for="(item, i) in info" :key="i">
            <v-expansion-panel-header class="font-weight-bold">
                {{ item.question }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                {{ item.answer }}
                <div
                    v-if="item.question === 'Apa itu level pada ambis meter?'"
                    class="mt-5"
                >
                    <v-card
                        v-for="(data, i) in level"
                        :key="i"
                        class="mb-5 pt-5"
                    >
                        <div class="d-flex flex-no-wrap pl-5">
                            <v-avatar size="75" tile
                                ><v-img :src="data.badge"></v-img
                            ></v-avatar>
                            <v-card-subtitle>{{
                                data.description
                            }}</v-card-subtitle>
                        </div>
                        <v-card-title class="text-h5 pl-7">{{
                            data.name
                        }}</v-card-title>
                    </v-card>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
import axios from "axios";

export default {
    name: "info-page",

    data: function () {
        return {
            info: [],
            level: [
                {
                    name: "Gold",
                    badge: require("@/assets/img/Gold_badge.png"),
                    color: "#F6B11E",
                    description:
                        "Gold merupakan rank pertama dan tertinggi dalam level ambis kamu",
                },
                {
                    name: "Silver",
                    badge: require("@/assets/img/Silver_badge.png"),
                    color: "#AEAEAF",
                    description:
                        "Silver merupakan rank kedua terendah dalam level ambis kamu",
                },
                {
                    name: "Bronze",
                    badge: require("@/assets/img/Bronze_badge.png"),
                    color: "#774E44",
                    description:
                        "Bronze merupakan rank ketiga terendah dalam level ambis kamu",
                },
            ],
        };
    },

    mounted: function () {
        this.fetchData();
    },

    methods: {
        fetchData: function () {
            var context = this;
            var url = "https://api.dev.skolla.online/ambis-meter/info";

            axios
                .get(url)
                .then(function (response) {
                    context.info = response.data;
                })
                .catch(function (error) {
                    console.log(error.message);
                });
        },
    },
};
</script>



// WEBPACK FOOTER //
// InfoPage.vue?6703fa40